<div class="card" (click)="onClick()">
  <img [src]="member.url" width="133" height="200" loading="lazy" [alt]="member.name" [ngStyle]="{'transform':  'rotate('+member.rotation+'deg)'}">
  <h3 style="text-align: center; margin-bottom: 0;">{{member.name}}</h3>
  <p style="text-align: center; margin-bottom: 1em; margin-top: .5em;">{{member.position}}</p>
</div>
